// extracted by mini-css-extract-plugin
export var bannerDescription = "s_bn";
export var bannerHeadline = "s_bf";
export var bannerItem = "s_bh";
export var bannerList = "s_bg";
export var bannerWrapper = "s_bd";